



































































































import { defineComponent, PropType } from '@vue/composition-api';
import IssueSummary from '../fields/IssueSummary.vue';
import { Issue } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import { useIssue } from '../../hooks/useIssue';
import { isOverseasVersion } from 'common-module/src/util';
import { IconMap } from '../message-card/search-assistant/const';
import { useRootInstance } from '../../../common-module/src/util/useRootInstance';
// @ts-ignore
// import { openPreviewDrawer } from 'file-preview';

type FileType = 'pdf' | 'docx' | 'md' | 'txt' | 'doc';

export default defineComponent({
  components: {
    IssueSummary
  },
  props: {
    list: {
      type: Array as PropType<Issue[]>,
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup () {
    const { t, tc } = useLocale();
    const { openIssue } = useIssue();
    const instance = useRootInstance();
    const getFileIcon = (fileName: string) => {
      const suffix = fileName.split('.').pop() as FileType;
      return IconMap[suffix] || 'iconDoc';
    };
    const openDoc = (uuid: string | null) => {
      if (!uuid) {
        return;
      }
      const documentDomain = (window as any)?.$config?.VUE_APP_DOCUMENT_SITE_DOMAIN || location.host.replace(/(\w+)/, '$1-docs');
      const path = `${location.protocol}//${documentDomain}/detail/${uuid}`;
      window.open(
        path,
        '_blank'
      );
    };
    // const checkCanPreview = (row: any) => {
    //   return false;
      // return row.linkUrl.endsWith('.pdf')
      //   || row.linkUrl.endsWith('.docx')
      //   || row.linkUrl.endsWith('.md')
      //   || row.linkUrl.endsWith('.txt')
      // || row.linkUrl.endsWith('.xlsx');
    // };
    const openFile = async(row: any) => {
      // if (checkCanPreview(row)) {
      //   openPreviewDrawer({
      //     url: row.linkUrl,
      //     name: row.summary
      //   });
      //   return;
      // }
      window.open(
        row.linkUrl,
        '_blank'
      );
    };

    const openHelpDoc = (row: any) => {
      window.open(
        row.path,
        '_blank'
      );
    };

    return {
      t,
      tc,
      toIssue(issue: Issue) {
        openIssue(issue);
      },
      openDoc,
      overseas: isOverseasVersion,
      getFileIcon,
      openFile,
      // checkCanPreview
      openHelpDoc
    };
  }
});
